import type { AvailableGameCatalogEntry } from '../../catalog-entry.js';
import { shuffleDemoDescriptor } from './descriptor.js';

export const shuffleDemoCatalogEntry = {
  descriptor: shuffleDemoDescriptor,
  availability: 'diagnostic',
  load: async () => (await import('./shuffle-demo.js')).shuffleDemoDefinition,
} satisfies AvailableGameCatalogEntry;
